<script lang="ts">
	import type { ComponentType } from 'svelte';
	import CmsDetailHeader from './CmsDetailHeader.svelte';
	import CmsEventTickets from './CmsEventTickets.svelte';
	import CmsFaq from './CmsFaq.svelte';
	import CmsRelatedEvents from './CmsRelatedEvents.svelte';
	import CmsTextImageTeaser from './CmsTextImageTeaser.svelte';
	import CmsImageTeaser from './CmsImageTeaser.svelte';
	import CmsHeadline from './CmsHeadline.svelte';
	import CmsCopytext from './CmsCopytext.svelte';
	import type { ICmsComponentBlock, ResourceClassName } from '../types';
	import CmsArticleIntro from './CmsArticleIntro.svelte';

	export let block: ICmsComponentBlock;

	function getComponent(block: ICmsComponentBlock): ComponentType | null {
		const resourceName = block.resource_class_name as ResourceClassName;

		switch (resourceName) {
			case 'DetailHeader':
				return CmsDetailHeader;
			case 'ArticleIntro':
				return CmsArticleIntro;
			case 'EventTickets':
				return CmsEventTickets;
			case 'Faq':
				return CmsFaq;
			case 'RelatedEvents':
				return CmsRelatedEvents;
			case 'TextImage':
				return CmsTextImageTeaser;
			case 'ImageTeaser':
				return CmsImageTeaser;
			case 'Headline':
				return CmsHeadline;
			case 'Copytext':
				return CmsCopytext;
			default:
				return null;
		}
	}

	const Component = getComponent(block);
</script>

{#if Component}
	<svelte:component this={Component} {...$$restProps} />
{/if}
